import { useEffect, useRef } from 'react';

export const useWheelNavigation = (ref: any, itemsLength: number, setSelectedIndex: any, isDisabled: boolean = false, onEnter?: () => void) => {
  const onEnterRef = useRef(onEnter);

  useEffect(() => {
    onEnterRef.current = onEnter;
  }, [onEnter]);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    if (container.getAttribute('tabIndex') === null) {
      container.tabIndex = 0;
      container.style.outline = 'none';
    }
    
    // Auto-focus container on load if nothing important is focused
    if (document.activeElement?.tagName !== 'INPUT' && !isDisabled) {
      container.focus({ preventScroll: true });
    }

    const handleWheel = (e: any) => {
      if (isDisabled) return;
      e.preventDefault(); 
      if (itemsLength === 0) return;
      if (e.deltaY > 0) setSelectedIndex((prev: number) => Math.min(itemsLength - 1, prev + 1));
      else if (e.deltaY < 0) setSelectedIndex((prev: number) => Math.max(0, prev - 1));
    };

    const handleKeyDown = (e: any) => {
      if (isDisabled) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        e.stopPropagation();
        if (itemsLength > 0) setSelectedIndex((prev: number) => Math.min(itemsLength - 1, prev + 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        e.stopPropagation();
        if (itemsLength > 0) setSelectedIndex((prev: number) => Math.max(0, prev - 1));
      } else if (e.key === 'Enter') {
        if (onEnterRef.current) {
          e.preventDefault();
          e.stopPropagation();
          onEnterRef.current();
        }
      }
    };

    container.addEventListener('wheel', handleWheel, { passive: false });
    container.addEventListener('keydown', handleKeyDown);
    return () => {
      container.removeEventListener('wheel', handleWheel);
      container.removeEventListener('keydown', handleKeyDown);
    };
  }, [itemsLength, setSelectedIndex, isDisabled, ref]);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;
    const t = setTimeout(() => {
      const activeEl = container.querySelector('.active-row');
      if (activeEl) {
        activeEl.scrollIntoView({ block: 'nearest' });
      }
    }, 0);
    return () => clearTimeout(t);
  });
};
